import { render } from "./AnnouncementDialog.vue?vue&type=template&id=362503c0"
import script from "./AnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./AnnouncementDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__